import type { ReminderPreferences } from '@portfolio-pm/shared';
import { ReminderPreferencesSchema } from '@portfolio-pm/shared';
import type * as Y from 'yjs';
import { type WithNow, ensureReminderPreferences, getReminderPreferencesMap } from './doc.ts';

export type UpdateReminderPreferencesInput = Partial<
  Pick<
    ReminderPreferences,
    'dueNudgesEnabled' | 'dueLeadMinutes' | 'scheduledNudgesEnabled' | 'scheduledLeadMinutes'
  >
>;

function ts(options: WithNow): number {
  return options.now ?? Date.now();
}

export function getReminderPreferences(doc: Y.Doc): ReminderPreferences {
  ensureReminderPreferences(doc);
  const map = getReminderPreferencesMap(doc);
  return ReminderPreferencesSchema.parse({
    dueNudgesEnabled: Boolean(map.get('dueNudgesEnabled')),
    dueLeadMinutes: Number(map.get('dueLeadMinutes') ?? 0),
    scheduledNudgesEnabled: Boolean(map.get('scheduledNudgesEnabled')),
    scheduledLeadMinutes: Number(map.get('scheduledLeadMinutes') ?? 0),
    createdAt: Number(map.get('createdAt') ?? 0),
    updatedAt: Number(map.get('updatedAt') ?? 0),
  });
}

export function updateReminderPreferences(
  doc: Y.Doc,
  patch: UpdateReminderPreferencesInput,
  options: WithNow = {},
): ReminderPreferences {
  const now = ts(options);
  ensureReminderPreferences(doc, now);
  const map = getReminderPreferencesMap(doc);

  doc.transact(() => {
    for (const [key, value] of Object.entries(patch) as [
      keyof UpdateReminderPreferencesInput,
      unknown,
    ][]) {
      if (value === undefined) continue;
      map.set(key, value);
    }
    map.set('updatedAt', now);
  });

  return getReminderPreferences(doc);
}
